<template>
<span>
<p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

<ol>
  <li>
    <p><span style="font-size:10pt">Berechnung des Innenerders im Stationsraum</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Berechnung des Schutzleiters zur HES</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Berechnung der HES</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Allgemeine Beschreibung (PDF-Dokument)</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Zeichnerische Darstellung der Erdungsanlage am und/oder im Gebäude</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Erstellung einer Materialstückliste der Komponenten für die Erdungsanlage</span></p>
  </li>
</ol>
</span>
</template>

<script>
export default {
  name: "TooltipDimensionierungErdungsanlage"
}
</script>

<style scoped>

</style>
